import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  render() {
    const { name, goldNum, giftImg } = this.props
    return (
      <div className="gift-item">
        <img src={giftImg} alt="" />
        <div className="name">{name}</div>
        <div className="gold">
          <span>{goldNum}</span>
          <img src="/img/gold.png" alt="" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/GiftItem/index.js